import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		loggedIn: false,
		loggingOut: false,
		nextUrl: null,
		dialog: {
			open: false,
			text: 'x',
			title: 'weeee',
			cancel: 'CANCELAR',
			confirm: 'REMOVER',
			width: false,
			heigth: false
		},
		pageModuleContents: [],
		permissions: [
			{ title: 'Usuários', value: 'users' },
			{ title: 'Cursos', value: 'courses' },
			{ title: 'Eventos', value: 'events' },
			{ title: 'Blog', value: 'blog' },
			{ title: 'Newsletter', value: 'newsletter' },
			{ title: 'Contatos', value: 'contacts' },
			{ title: 'Páginas', value: 'pages' },
			{ title: 'FAQ - Perguntas Frequentes', value: 'faq' },
			{ title: 'Menu', value: 'menu' },
			{ title: 'Imagens', value: 'images' },
			{ title: 'Alunos Certificados', value: 'students' },
			{ title: 'Termo de Consentimento', value: 'students_terms' },
			{ title: 'Gerenciar PDF Termos', value: 'term_files' },
            { title: 'Logs do sistema', value: 'user_logs' },
		],
		userPermissions: [],
		course: {
			faqItems: [],
			data: {
				dates: []
			}
		},
		page: {
			//
		},
		flashs: {
			success: [],
			warnings: [],
			errors: []
		},
		current_menu: '',
        notification: {
            unreadCount: 0,
            list: [],
            loadingList: false,
            updatingItem: false,
            updatingList: false,
        },
	},
	getters: {
		getUserPagePermission: state => page => {
			return false;
		}
	},
	mutations: {
		set_permission: function( state, payload ) {
			state.userPermissions = JSON.parse(payload)
		},
		set_course_faq: function( state, payload ){
			state.course.faqItems = payload
		},
		set_course_dates: function( state, payload ){
			state.course.data.dates = payload
		},
		set_course_data: function( state, payload ) {
			payload.dates = JSON.parse(payload.dates);
			state.course.data = payload;
		},
		flash_success: function( state, payload ) {
			state.flashs.success.push(payload);
		},
		flash_warning: function( state, payload ) {
			state.flashs.warnings.push(payload);
		},
		flash_error: function( state, payload ) {
			state.flashs.errors.push(payload);
		},
		flash_clear: function( state, payload ){
			state.flashs[payload] = [];
		},

		set_currentMenu: function( state, payload ){
			state.current_menu = payload
		},
		// PAGE
		set_page: function( state, payload ){
			state.page = payload
		},
		set_pagedata( state, payload )
		{
			state.page[payload.field] = payload.data;
			// console.log( state.page );
		},
        // NOTIFICATION
        set_notification_unread_count ( state, payload )
        {
            if (+payload.count > +state.notification.unreadCount) {
                state.notification.list = []
            }
            state.notification.unreadCount = +payload.count
        },
        set_notifications ( state, payload )
        {
            state.notification.list = payload
        },
        set_notification_read ( state, payload )
        {
            state.notification.unreadCount -= 1
            state.notification.list = state.notification.list.map((item) => {
                if (item.id === payload.id) {
                    item.unread = false
                }
                return item
            })
        },
        set_all_notifications_read ( state )
        {
            state.notification.unreadCount = 0
            state.notification.list = state.notification.list.map((item) => {
                item.unread = false
                return item
            })
        },
	},
	actions: {
		// ..
	}
})
